// import React, { useEffect, useState } from "react";

// import axios from "axios";
// import {
//   Accordion,
//   Button,
//   Card,
//   Col,
//   Form,
//   Modal,
//   Nav,
//   Row,
//   Tab,
// } from "react-bootstrap";
// import { useDropzone } from "react-dropzone";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { logoMaker, removeToken } from "../helpers/helper";
// import { cprofilelogo, starIcon } from "../images/assest";
// import imgpEdit from "../images/icons/edit-01.svg";
// import imgplusIcon from "../images/icons/image-plus.svg";
// import imgpTrash from "../images/icons/trash-01.svg";
// import AddUserManagement from "./AddUserManagement";
// import TextEditor from "./TextEditor";
// import { IndustrySelection, LocationSelection } from "../services/provider";
// import { useNavigate } from "react-router-dom";

// const CompanyEditProfile = ({ show, handleClose }) => {
//   const companyProfileDetails = useSelector(
//     (state) => state.login.CompanyProfileDetails
//   );
//   const compantUid = companyProfileDetails?.uid
//   const userInfo = useSelector((state) => state.login.loginUserInfo);
//   const uid = userInfo?.uid;
//   const [industries, setIndustries] = useState([]);
//   const [selectedIndustry, setSelectedIndustry] = useState(null);

//   const [Location, setLocation] = useState([]);
//   const [selectedLocation, setSelectedLocation] = useState(null);

//   const [description, setDescription] = useState(
//     companyProfileDetails?.description || ""
//   );
//   const [website, setWebsite] = useState(
//     companyProfileDetails?.website_url || ""
//   );

//   const [IndustrySearch, SetIndustrySearch] = useState(
//     companyProfileDetails?.industry?.industry_name || ""
//   );
//   const [IndustrySearchDropdown, setIndustrySearchDropdown] = useState(false);
//   const [LocationSearchDropdown, setLocationSearchDropdown] = useState(false);

//   const [selectedCompanyType, setSelectedCompanyType] = useState(
//     companyProfileDetails?.company_type || ""
//   );
//   const [noOfEmploy, setnoOfEmploy] = useState(
//     companyProfileDetails?.number_of_employees || ""
//   );
//   const [searchLocationTerm, setLocationSearchTerm] = useState(
//     companyProfileDetails?.location?.location_name || ""
//   ); //location state

//   // other state
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [customModalshowcustomModal, setCustomShowModal] = useState(false);
//   const [companyUpdateError, setCompanyUpdateError] = useState({
//     websiteError: "",
//     logoError: "",
//   });
//   const [completionPercentage, setCompletionPercentage] = useState(0);
//   const [ids, setIds] = useState({
//     industryName: companyProfileDetails?.industry?.industry_name,
//     industryUid: companyProfileDetails?.industry?.uid,
//     location_name: companyProfileDetails?.location?.location_name,
//     locationUid: companyProfileDetails?.location?.uid,
//   });

//   // cropping img state
//   const [image, setImage] = useState(
//     `https://api-jaipur.lywo.in${companyProfileDetails?.logo}` || null
//   );
//   const [imageName, setImageName] = useState("");
//   const [zoom, setZoom] = useState(1);
//   const [aspectRatio, setAspectRatio] = useState(1);
//   const [showLogoModal, setLogoModal] = useState(false);
//   const [imageFile, setImageFile] = useState(null);

//   const navigate = useNavigate();

//   const aspectRatios = [
//     { label: "1:1", value: 3 / 2 },
//     { label: "2:3", value: 1 },
//   ];

//   const handleImageChange = (acceptedFiles) => {
//     const file = acceptedFiles[0];
//     if (file) {
//       setImage(URL.createObjectURL(file));
//       setImageName(file.name);
//       setLogoModal(true);
//       // console.log("file------",file)
//       setImageFile(file);
//     }
//   };

//   const { getRootProps, getInputProps } = useDropzone({
//     accept: "image/*",
//     onDrop: handleImageChange,
//   });

//   const handleAspectRatioChange = (e) => {
//     setAspectRatio(parseFloat(e.target.value));
//   };

//   const zoomIn = () => {
//     if (zoom < 3) {
//       setZoom(zoom + 0.5);
//     }
//   };

//   const zoomOut = () => {
//     if (zoom > 1) {
//       setZoom(zoom - 0.5);
//     }
//   };

//   const handleSave = () => {
//     setLogoModal(false);
//   };

//   const LogoModal = () => {
//     const imageHeight = 300 / aspectRatio;

//     return (
//       <div className="ctm_modal_dialog">
//         <div className="ctm_modal_content">
//           <Modal.Header closeButton>
//             <Modal.Title>
//               <img src={imgplusIcon} className="me-2" />
//               Add Company Logo
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="aspect_ratio">
//               <label> Select Aspect Ratio</label>
//               {aspectRatios.map((ratio) => (
//                 <label
//                   key={ratio.value}
//                   style={radioButtonStyle}
//                   className="me-3"
//                 >
//                   <input
//                     type="radio"
//                     value={ratio.value}
//                     checked={aspectRatio === ratio.value}
//                     onChange={handleAspectRatioChange}
//                   />
//                   {ratio.label}
//                 </label>
//               ))}
//             </div>

//             <div className="cropper-container">
//               <div class="cropper-wrap-box">
//                 <img
//                   src={image}
//                   alt="Selected"
//                   style={{
//                     width: "200px",
//                     height: `${imageHeight}px`,
//                     maxHeight: "300px",
//                     transform: `scale(${zoom})`,
//                     transition: "transform 0.2s ease-in-out",
//                   }}
//                 />
//               </div>
//             </div>

//             <div className="zoomin_cntrols">
//               <button onClick={zoomOut} className="icon_btn">
//                 -
//               </button>
//               <progress
//                 value={zoom - 1}
//                 max="2"
//                 style={{ width: "100%", height: "14px" }}
//               />
//               <button onClick={zoomIn} className="icon_btn">
//                 +
//               </button>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button onClick={handleSave} variant="primary">
//               Save
//             </Button>
//           </Modal.Footer>
//         </div>
//       </div>
//     );
//   };

//   const handleShowcustomModal = () => setCustomShowModal(true);
//   const handlecustomModalClose = () => setCustomShowModal(false);

//   // const userInfo = useSelector((state) => state.login.loginUserInfo);
//   // const uid = userInfo?.uid;

//   const logoname = logoMaker(companyProfileDetails?.company_name);

//   const CustomModal = ({ show, handleClose }) => {
//     return (
//       <Modal
//         show={show}
//         onHide={handleClose}
//         className="confirmation_model"
//         aria-labelledby="contained-modal-title-vcenter"
//         centered
//       >
//         <Modal.Header closeButton></Modal.Header>
//         <Modal.Body className="text-center">
//           <h3>
//             Are you sure<br></br> you want to save changes?
//           </h3>
//           <p>Changes will be applied to all current jobs.</p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="light" onClick={handleClose}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={updateCompanyProfile}>
//             Save
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     );
//   };

//   const calculateProfileCompletion = () => {
//     let completionPercentage = 0;

//     if (companyProfileDetails?.company_name?.trim()) completionPercentage += 20;
//     if (companyProfileDetails?.description?.trim()) {
//       const wordCount = companyProfileDetails?.description
//         .trim()
//         .split(/\s+/).length;
//       completionPercentage += wordCount < 100 ? 10 : 30;
//     }
//     if (companyProfileDetails?.logo) completionPercentage += 10;
//     if (companyProfileDetails?.number_of_employees) completionPercentage += 10;
//     if (companyProfileDetails?.company_type) completionPercentage += 5;
//     if (companyProfileDetails?.location) completionPercentage += 10;
//     if (companyProfileDetails?.website_url) completionPercentage += 5;
//     if (companyProfileDetails?.industry) completionPercentage += 10;

//     return Math.min(completionPercentage, 100);
//   };

//   const handleIndustrySelect = (industryName) => {
//     setSelectedIndustry({
//       industryName: industryName?.industry_name,
//       industryUid: industryName?.uid,
//     });
//     setIds({
//       ...ids,
//       industryName: industryName?.industry_name,
//       industryUid: industryName?.uid,
//     });

//     SetIndustrySearch(industryName?.industry_name);
//     setIndustrySearchDropdown(false);
//     setIndustries([]);
//   };

//   const handleIndustrySearchChange = (e) => {
//     SetIndustrySearch(e.target.value);
//     setIndustrySearchDropdown(true);
//   };

//   const isHeadQuerterHandleApi = (LocationQuery) => {
//     const url = `https://api-jaipur.lywo.in/account-api/location-list-api/?page=1&limit=500&search=${LocationQuery}`;
//     LocationSelection(url)
//       .then((res) => {
//         setLocation(res.data.response);
//       })
//       .catch((error) => {
//         if (
//           error?.response?.status === 401 ||
//           error?.response?.data?.detail?.includes(
//             "Given token not valid for any token type"
//           )
//         ) {
//           removeToken();
//           navigate("/loginwithpassword");
//         }
//       });
//   };

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       isHeadQuerterHandleApi(searchLocationTerm);
//     }, 500);
//     return () => {
//       clearTimeout(timeoutId);
//     };
//   }, [searchLocationTerm]);

//   const handleLocationSelect = (LocationName) => {
//     setSelectedLocation({
//       name: LocationName?.location_name,
//       uid: LocationName?.uid,
//     });
//     setIds({
//       ...ids,
//       locationUid: LocationName?.uid,
//       location_name: LocationName?.location_name,
//     });
//     setLocationSearchTerm(LocationName?.location_name);
//     setLocationSearchDropdown(false);
//     setLocation([]);
//   };

//   const handleLocationSearchChange = (e) => {
//     setLocationSearchTerm(e.target.value);
//     setLocationSearchDropdown(true);
//   };

//   const updateCompanyProfile = async () => {
//     if (companyUpdateError?.websiteError) {
//       console.log("Invalid URL, cannot submit.");
//       return;
//     }

//     try {
//       const data = new FormData();

//       data.append("description", description);
//       data.append("website_url", website);
//       data.append("company_type", selectedCompanyType);
//       data.append("number_of_employees", noOfEmploy);
//       data.append("industry", ids?.industryUid);
//       data.append("location", ids?.locationUid);
//       data.append("logo", imageFile);

//       const response = await axios.put(
//         `https://api-jaipur.lywo.in/account-api/update-company-api/${compantUid}/`,
//         data,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       if (response === 200) {
//         setCompanyUpdateError((prevState) => ({
//           ...prevState,
//           websiteError: "", // Clear websiteError on successful update
//         }));
//       }
//     } catch (error) {
//       // console.log("erooor------>>>", error);
//       // setCompanyUpdateError.websiteError(error?.response?.data?.response?.website_url[0]);
//       const errorResponse = error?.response?.data?.response;

//       // Update the state with the appropriate error messages
//       setCompanyUpdateError((prevState) => ({
//         ...prevState,
//         websiteError: errorResponse?.website_url?.[0] || "",
//         logoError: errorResponse?.logo_url?.[0] || "", // Handle logo error if available
//       }));
//     }

//     handlecustomModalClose();
//     handleClose();
//   };

//   const handleUpdate = (updatedDescription) => {
//     setDescription(updatedDescription);
//   };

//   const handleWebsite = (e) => {
//     const url = e.target.value;
//     setWebsite(url);

//     const websiteError =
//     !url || /^(https?:\/\/|www\.)\S+$/.test(url) ? "" : "Invalid Website URL";

//     setCompanyUpdateError((prevState) => ({
//       ...prevState,
//       websiteError,
//     }));
//   };

//   const handleCompanyTypeChange = (e) => {
//     setSelectedCompanyType(e.target.value);
//   };

//   const handleNoOfTypeEmployChange = (e) => {
//     setnoOfEmploy(e.target.value);
//   };

//   const handleDeleteImage = () => {
//     setImage(null);
//     setImageName("");
//     setImageFile("");
//     toast.success("Logo delete Press save button!");
//   };

//   const handleEditImage = () => {
//     if (image || companyProfileDetails?.logo !== null) {
//       setLogoModal(true);
//     }
//   };

//   useEffect(() => {
//     setCompletionPercentage(calculateProfileCompletion());
//   }, [companyProfileDetails]);

//   const isIndustryHandleApi = (query) => {
//     const url = `https://api-jaipur.lywo.in/account-api/industry-list-api/?page=1&limit=500&search=${query}`;
//     IndustrySelection(url)
//       .then((res) => {
//         setIndustries(res.data.response);
//       })
//       .catch((error) => {
//         if (
//           error?.response?.status === 401 ||
//           error?.response?.data?.detail?.includes(
//             "Given token not valid for any token type"
//           )
//         ) {
//           //console.log("Token expired, redirecting to login");
//           removeToken();
//           navigate("/loginwithpassword");
//         }
//       });
//   };

//   useEffect(() => {
//     const timeoutId = setTimeout(() => {
//       isIndustryHandleApi(IndustrySearch);
//     }, 500);
//     return () => {
//       clearTimeout(timeoutId);
//     };
//   }, [IndustrySearch]);

//   const filePath = companyProfileDetails?.logo;

//   const LogoName = filePath?.split("/").pop();

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       animation={false}
//       size="lg"
//       className="cmprofile_mdl"
//     >
//       <Tab.Container id="left-tabs-example" defaultActiveKey="first">
//         <Row>
//           <aside className="model_sidebar col-md-2">
//             <div className="md_sdrlogo">
//               <img src={cprofilelogo} alt="" onClick={handleClose} />
//             </div>
//             <Nav variant="pills" className="flex-column mdl_sdbarmenu">
//               <Nav.Item>
//                 <Nav.Link eventKey="first">
//                   Profile<span>{completionPercentage}% Complete</span>
//                 </Nav.Link>
//               </Nav.Item>
//               <Nav.Item>
//                 <Nav.Link eventKey="second">
//                   Users
//                   <span>
//                     {companyProfileDetails?.active_user} Active,
//                     {companyProfileDetails?.pending_user} Pending
//                   </span>
//                 </Nav.Link>
//               </Nav.Item>
//             </Nav>
//           </aside>
//           <Col md={10} className="cprofile_right">
//             <Modal.Header closeButton className="fixed-header">
//               <Modal.Title>Company Settings</Modal.Title>
//             </Modal.Header>
//             <Tab.Content>
//               <Tab.Pane eventKey="first">
//                 <Modal.Body>
//                   <Row>
//                     <Col md={12}>
//                       <div className="mdl_pagetitle d-flex justify-content-between align-items-center">
//                         <h5>Basic Information</h5>
//                         <div className="btn_group">
//                           <Button
//                             variant="link"
//                             className="me-2"
//                             onClick={handleClose}
//                           >
//                             Cancel
//                           </Button>
//                           <Button
//                             variant="primary"
//                             onClick={handleShowcustomModal}
//                             disabled={!!companyUpdateError?.websiteError}
//                           >
//                             Save
//                           </Button>
//                           <CustomModal
//                             show={customModalshowcustomModal}
//                             handleClose={handlecustomModalClose}
//                           />
//                         </div>
//                       </div>
//                       <Card className="form_card">
//                         <Card.Body>
//                           <Form>
//                             <Row>
//                               <Col md={6}>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label className="required">
//                                     Company Name
//                                   </Form.Label>
//                                   <Form.Control
//                                     type="text"
//                                     placeholder="Company Name"
//                                     value={companyProfileDetails?.company_name}
//                                   />
//                                 </Form.Group>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Description</Form.Label>
//                                   <TextEditor
//                                     data={companyProfileDetails?.description}
//                                     onUpdate={handleUpdate}
//                                   />
//                                 </Form.Group>
//                               </Col>
//                               <Col md={6}>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Website</Form.Label>
//                                   <Form.Control
//                                     type="url"
//                                     placeholder="Website"
//                                     onChange={handleWebsite}
//                                     value={website}
//                                   />
//                                 </Form.Group>
//                                 {companyUpdateError?.websiteError && (
//                                   <p className="error">
//                                     {companyUpdateError?.websiteError}
//                                   </p>
//                                 )}

//                                 <Form.Group className="col-md-12 mb-3 relative">
//                                   <Form.Label>Industry</Form.Label>
//                                   <Form.Control
//                                     type="text"
//                                     placeholder="Search for an industry.."
//                                     value={IndustrySearch}
//                                     onChange={handleIndustrySearchChange}
//                                   />

//                                   {IndustrySearchDropdown &&
//                                     industries.length > 0 && (
//                                       <div className="ctm_dropdown ct_scrollbar">
//                                         <ul>
//                                           {industries.map(
//                                             (industry) =>
//                                               IndustrySearch !==
//                                                 industry?.industry_name && (
//                                                 <li
//                                                   key={industry.id}
//                                                   onClick={() =>
//                                                     handleIndustrySelect(
//                                                       industry
//                                                     )
//                                                   }
//                                                 >
//                                                   {industry?.industry_name}
//                                                 </li>
//                                               )
//                                           )}
//                                         </ul>
//                                       </div>
//                                     )}

//                                   {IndustrySearchDropdown &&
//                                     industries.length === 0 && (
//                                       <ul>
//                                         <li>No data found</li>
//                                       </ul>
//                                     )}
//                                 </Form.Group>

//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Company Type</Form.Label>
//                                   <Form.Select
//                                     aria-label="Default select example"
//                                     value={selectedCompanyType}
//                                     onChange={handleCompanyTypeChange}
//                                   >
//                                     <option>
//                                       {companyProfileDetails?.company_type
//                                         ? companyProfileDetails?.company_type
//                                         : "Company Type"}
//                                       {/* {selectedCompanyType} */}
//                                     </option>
//                                     <option value="Publice-Company">
//                                       Public Company
//                                     </option>
//                                     <option value="Self-employed">
//                                       Self-employed
//                                     </option>
//                                     <option value="Government-Agency">
//                                       Government Agency
//                                     </option>
//                                     <option value="Nonprofit">Nonprofit</option>
//                                     <option value="Sole-Proprietorship">
//                                       Sole Proprietorship
//                                     </option>
//                                     <option value="Privately-held">
//                                       Privately held
//                                     </option>
//                                     <option value="Partnership">
//                                       Partnership
//                                     </option>
//                                   </Form.Select>
//                                 </Form.Group>
//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Company Size</Form.Label>
//                                   <Form.Select
//                                     aria-label="Default select example"
//                                     value={noOfEmploy}
//                                     onChange={handleNoOfTypeEmployChange}
//                                   >
//                                     <option>
//                                       {companyProfileDetails?.number_of_employees
//                                         ? companyProfileDetails?.number_of_employees
//                                         : "Company Size"}
//                                     </option>

//                                     <option value="1-5-employees">
//                                       1 - 5 employees
//                                     </option>
//                                     <option value="6-10-employees">
//                                       6 - 10 employees
//                                     </option>
//                                     <option value="11-50-employees">
//                                       11 - 50 employees
//                                     </option>
//                                     <option value="51-200-employees">
//                                       {" "}
//                                       51 - 200 employees{" "}
//                                     </option>

//                                     <option value="201-500-employees">
//                                       201 - 500 employees
//                                     </option>
//                                     <option value="501-1,000-employees">
//                                       501 - 1,000 employees
//                                     </option>
//                                     <option value="1,001-5,000-employees">
//                                       1,001 - 5,000 employees
//                                     </option>
//                                     <option value="5,001-10,000-employees">
//                                       5,001 - 10,000 employees
//                                     </option>
//                                     <option value="More-than-10000-employees">
//                                       More than 10,000 employees
//                                     </option>
//                                   </Form.Select>
//                                 </Form.Group>

//                                 <Form.Group className="mb-3 relative">
//                                   <Form.Label>Headquarter</Form.Label>
//                                   <Form.Control
//                                     type="text"
//                                     placeholder="Search for an Headquarter..."
//                                     value={searchLocationTerm}
//                                     onChange={handleLocationSearchChange}
//                                   />

//                                   {LocationSearchDropdown &&
//                                     Location.length > 0 && (
//                                       <div className="ctm_dropdown ct_scrollbar">
//                                         <ul>
//                                           {Location.map(
//                                             (item) =>
//                                               searchLocationTerm !==
//                                                 item?.location_name && (
//                                                 <li
//                                                   key={item.id}
//                                                   onClick={() =>
//                                                     handleLocationSelect(item)
//                                                   }
//                                                 >
//                                                   {item?.location_name}
//                                                 </li>
//                                               )
//                                           )}
//                                         </ul>
//                                       </div>
//                                     )}

//                                   {LocationSearchDropdown &&
//                                     Location.length === 0 && (
//                                       <ul>
//                                         <li>No data found</li>
//                                       </ul>
//                                     )}
//                                 </Form.Group>

//                                 <Form.Group className="mb-3">
//                                   <Form.Label>Add Company Logo</Form.Label>

//                                   {!companyProfileDetails?.logo &&
//                                   !imageFile ? (
//                                     <div
//                                       className="cmp_uploder file-upload-box"
//                                       {...getRootProps()}
//                                     >
//                                       <div className="upload-content">
//                                         <input {...getInputProps()} />
//                                         <i className="fas fa-cloud-upload-alt upload-icon"></i>
//                                         <h5>
//                                           <strong className="text-primary">
//                                             Click to upload
//                                           </strong>{" "}
//                                           or Drag & Drop
//                                         </h5>
//                                         <small className="text-muted mb-0">
//                                           SVG, PNG, JPG or GIF (Recommended
//                                           aspect ratio: 1:1 or 2:3)
//                                         </small>
//                                       </div>
//                                     </div>
//                                   ) : (
//                                     <div className="selected_logo">
//                                       {LogoName ? (
//                                         <label>{LogoName}</label>
//                                       ) : (
//                                         <label>{imageName}</label>
//                                       )}
//                                       <div className="d-flex">
//                                         <Button
//                                           variant="link"
//                                           onClick={handleEditImage}
//                                         >
//                                           <img src={imgpEdit} />
//                                         </Button>
//                                         <Button
//                                           variant="link"
//                                           className=" me-2"
//                                           onClick={handleDeleteImage}
//                                         >
//                                           <img src={imgpTrash} />
//                                         </Button>
//                                       </div>
//                                     </div>
//                                   )}

//                                   {showLogoModal && (
//                                     <LogoModal
//                                       onClose={() => setLogoModal(false)}
//                                     />
//                                   )}

//                                   {companyUpdateError.logoError && (
//                                     <p className="error-message">
//                                       {companyUpdateError.logoError}
//                                     </p>
//                                   )}
//                                 </Form.Group>
//                               </Col>
//                             </Row>
//                           </Form>
//                         </Card.Body>
//                       </Card>
//                     </Col>
//                     <Col md={3} className="cmp_details sd-rightFixed">
//                       <Accordion defaultActiveKey="0" flush>
//                         <Accordion.Item eventKey="0">
//                           <Accordion.Header>Company Details</Accordion.Header>
//                           <Accordion.Body>
//                             {companyProfileDetails?.logo !== null ? (
//                               <div className="cmp_logo mt-1">
//                                 <span className="cmp_textlogo">
//                                   <img
//                                     src={`https://api-jaipur.lywo.in${companyProfileDetails?.logo}`}
//                                     alt="Logo"
//                                   />
//                                 </span>
//                               </div>
//                             ) : (
//                               <div className="cmp_logo mt-1">
//                                 <span className="cmp_textlogo">{logoname}</span>
//                               </div>
//                             )}

//                             <ul className="cmp_info ct_scrollbar">
//                               <li>
//                                 <strong>
//                                   {companyProfileDetails?.company_name}
//                                 </strong>
//                               </li>
//                               <li>
//                                 {website
//                                   ? website
//                                   : companyProfileDetails?.website_url}
//                               </li>
//                               <li>
//                                 {IndustrySearch
//                                   ? IndustrySearch
//                                   : companyProfileDetails?.industry
//                                       ?.industry_name}
//                               </li>
//                               <li>
//                                 {selectedCompanyType
//                                   ? selectedCompanyType
//                                   : companyProfileDetails?.company_type}
//                               </li>
//                               <p
//                                 dangerouslySetInnerHTML={{
//                                   __html: companyProfileDetails?.description,
//                                 }}
//                               />
//                               <li>
//                                 {noOfEmploy
//                                   ? noOfEmploy
//                                   : companyProfileDetails?.number_of_employees}
//                               </li>
//                               <li>
//                                 {searchLocationTerm
//                                   ? searchLocationTerm
//                                   : companyProfileDetails?.location
//                                       ?.location_name}
//                               </li>
//                             </ul>
//                           </Accordion.Body>
//                         </Accordion.Item>
//                       </Accordion>
//                       <div className="rects-panel bottom-fixed">
//                         <h5>Recommendations</h5>
//                         <ul className="rects_list">
//                           {!companyProfileDetails?.logo && (
//                             <li>
//                               <img src={starIcon} />
//                               Add Logo
//                             </li>
//                           )}

//                           {(!companyProfileDetails?.website_url ||
//                             companyProfileDetails.website_url.trim() === "") &&
//                             !website && (
//                               <li>
//                                 <img src={starIcon} alt="star" />
//                                 Add Website
//                               </li>
//                             )}

//                           {!companyProfileDetails?.industry &&
//                             !IndustrySearch && (
//                               <li>
//                                 <img src={starIcon} />
//                                 Add Industry Type
//                               </li>
//                             )}

//                           {(!companyProfileDetails?.description ||
//                             companyProfileDetails.description
//                               .replace(/<[^>]*>/g, "")
//                               .trim() === "") && (
//                             <li>
//                               <img src={starIcon} alt="star" />
//                               Add Description
//                             </li>
//                           )}

//                           {(!companyProfileDetails?.selectedCompanyType &&
//                             !selectedCompanyType) ||
//                             (selectedCompanyType == "Company Type" && (
//                               <li>
//                                 <img src={starIcon} />
//                                 Add Company Type
//                               </li>
//                             ))}

//                           {(!companyProfileDetails?.number_of_employees &&
//                             !noOfEmploy) ||
//                             (noOfEmploy == "Company Size" && (
//                               <li>
//                                 <img src={starIcon} />
//                                 Add Company Size
//                               </li>
//                             ))}

//                           {!companyProfileDetails?.location &&
//                             !searchLocationTerm && (
//                               <li>
//                                 <img src={starIcon} />
//                                 Add Headquarter
//                               </li>
//                             )}
//                         </ul>
//                       </div>
//                     </Col>
//                   </Row>
//                 </Modal.Body>
//               </Tab.Pane>
//               <Tab.Pane eventKey="second">
//                 <Modal.Body>
//                   <AddUserManagement />
//                 </Modal.Body>
//               </Tab.Pane>
//             </Tab.Content>
//           </Col>
//         </Row>
//       </Tab.Container>
//     </Modal>
//   );
// };

// const radioButtonStyle = {
//   display: "block",
//   margin: "10px 0",
//   cursor: "pointer",
// };

// export default CompanyEditProfile;

import React, { useEffect, useState } from "react";

import axios from "axios";
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Nav,
  Row,
  Tab,
} from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { logoMaker, removeToken } from "../helpers/helper";
import { cprofilelogo, starIcon } from "../images/assest";
import imgpEdit from "../images/icons/edit-01.svg";
import imgplusIcon from "../images/icons/image-plus.svg";
import CrossIcon from "../images/icons/Cross-Icon.svg";
import HelpIcon from "../images/icons/Help-icon-gray.svg";
import imgpTrash from "../images/icons/trash-01.svg";
import AddUserManagement from "./AddUserManagement";
import TextEditor from "./TextEditor";
import { IndustrySelection, LocationSelection } from "../services/provider";
import { useNavigate } from "react-router-dom";
import { isBinaryFile } from "../utils/test";
import Select from 'react-select';

const CompanyEditProfile = ({ show, handleClose }) => {
  const companyProfileDetails = useSelector(
    (state) => state.login.CompanyProfileDetails
  );
  console.log(companyProfileDetails)
  const compantUid = companyProfileDetails?.uid;
  const userInfo = useSelector((state) => state.login.loginUserInfo);
  const uid = userInfo?.uid;
  const [industries, setIndustries] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const [Location, setLocation] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [description, setDescription] = useState("");
  const [website, setWebsite] = useState("");


  // custom style react select box

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#deebff"
        : state.isFocused
          ? "#deebff" // Color on hover
          : "inherit",
      color: state.isSelected ? "#000" : "black",
      cursor: "pointer", // Optional: improves UX on hover
    }),
  };

  const [IndustrySearch, SetIndustrySearch] = useState("");
  const [IndustrySearchDropdown, setIndustrySearchDropdown] = useState(false);
  const [LocationSearchDropdown, setLocationSearchDropdown] = useState(false);

  const [selectedCompanyType, setSelectedCompanyType] = useState("");
  const [companyTypeValue, setCompanyTypeValue] = useState(null);
  const [companySizeValue, setCompanySizeValue] = useState(null);
  const [noOfEmploy, setnoOfEmploy] = useState("");
  const [searchLocationTerm, setLocationSearchTerm] = useState(""); //location state

  // other state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [customModalshowcustomModal, setCustomShowModal] = useState(false);
  const [companyUpdateError, setCompanyUpdateError] = useState({
    websiteError: "",
    logoError: "",
  });
  const [completionPercentage, setCompletionPercentage] = useState(0);
  const [ids, setIds] = useState({
    industryName: "",
    industryUid: "",
    location_name: "",
    locationUid: "",
  });
  const companyTypeOption = [
    { value: "Public-Company", label: "Public Company" },
    { value: "Self-employed", label: "Self employed" },
    { value: "Government-Agency", label: "Government Agency" },
    { value: "Nonprofit", label: "Nonprofit" },
    { value: "Sole-Proprietorship", label: "Sole Proprietorship" },
    { value: "Privately-held", label: "Privately held" },
    { value: "Partnership", label: "Partnership" },
  ]
  const companySizeOption = [
    { value: "1-5-employees", label: "1 - 5 employees" },
    { value: "6-10-employees", label: "6 - 10 employees" },
    { value: "11-50-employees", label: "11 - 50 employees" },
    { value: "51-200-employees", label: "51 - 200 employees" },
    { value: "201-500-employees", label: "201 - 500 employees" },
    { value: "501-1,000-employees", label: "501 - 1,000 employees" },
    { value: "1,001-5,000-employees", label: "1,001 - 5,000 employees" },
    { value: "5,001-10,000-employees", label: "5,001 - 10,000 employees" },
    { value: "More-than-10000-employees", label: "More than 10000 employees" },
  ]

  //console.log("logooo-----",companyProfileDetails?.logo)
  // cropping img state
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState("");
  const [zoom, setZoom] = useState(1);
  const [aspectRatio, setAspectRatio] = useState(1);
  const [showLogoModal, setLogoModal] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [checkEditImage, setCheckEditImage] = useState(false);
  const [croppedImage, setCroppedImage] = useState(null);

  useEffect(() => {
    setDescription(companyProfileDetails?.description)
    setWebsite(companyProfileDetails?.website_url)
    SetIndustrySearch(companyProfileDetails?.industry?.industry_name)
    setSelectedCompanyType(companyProfileDetails?.company_type)
    setnoOfEmploy(companyProfileDetails?.number_of_employees)
    setLocationSearchTerm(companyProfileDetails?.location?.location_name)
    setIds({
      industryName: companyProfileDetails?.industry?.industry_name,
      industryUid: companyProfileDetails?.industry?.uid,
      location_name: companyProfileDetails?.location?.location_name,
      locationUid: companyProfileDetails?.location?.uid,
    })
    const filePath = companyProfileDetails?.logo;
    setImageFile(filePath)
    const LogoName = filePath?.split("/").pop();
    setImageName(LogoName);
    setImage(companyProfileDetails?.logo ? `https://api-jaipur.lywo.in${companyProfileDetails?.logo}` : "")
    setCroppedImage(companyProfileDetails?.logo ? `https://api-jaipur.lywo.in${companyProfileDetails?.logo}` : "")
    const matchType = companyTypeOption.find((opt) => opt.value === companyProfileDetails?.company_type)
    if (matchType) setCompanyTypeValue(matchType)
    const matchSize = companySizeOption.find((opt) => opt.value === companyProfileDetails?.number_of_employees)
    if (matchSize) setCompanySizeValue(matchSize)
  }, [companyProfileDetails])
  const [isZoomedImg, setIsZoomedImg] = useState(false);

  const navigate = useNavigate();

  const aspectRatios = [
    { label: "1:1", value: 3 / 2 },
    { label: "2:3", value: 1 },
  ];

  const handleImageChange = (acceptedFiles) => {
    const file = acceptedFiles[0];

    if (file) {
      setImage(URL.createObjectURL(file));
      // setImage(`https://api-jaipur.lywo.in/${file.name}`);
      setImageName(file.name);
      setLogoModal(true);
      setImageFile(file);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: handleImageChange,
  });

  const handleAspectRatioChange = (e) => {
    setAspectRatio(parseFloat(e.target.value));
  };

  const zoomIn = () => {
    if (zoom < 3) {
      setZoom(zoom + 0.5);
      setIsZoomedImg(true);
    } else {
      setLogoModal(false);
      setIsZoomedImg(false);
      alert("You cannot zoom in further. Maximum zoom level reached.");
    }
  };

  const zoomOut = () => {
    if (zoom > 1) {
      setZoom(zoom - 0.5);
      setIsZoomedImg(true);
    } else {
      setLogoModal(false);
      setIsZoomedImg(false);
      alert("You cannot zoom out further. Minimum zoom level reached.");
    }
  };

  // const handleSave = () => {
  //   const img = new Image();
  //   console.log("iiiiiii---->>>",image)
  //   img.src = image;

  //   img.onload = () => {
  //     const canvas = document.createElement("canvas");
  //     const ctx = canvas.getContext("2d");

  //     const desiredWidth = 200;
  //     const desiredHeight = desiredWidth / aspectRatio;

  //     canvas.width = desiredWidth;
  //     canvas.height = desiredHeight;

  //     const scaledWidth = img.width * zoom;
  //     const scaledHeight = img.height * zoom;

  //     const dx = (desiredWidth - scaledWidth) / 2;
  //     const dy = (desiredHeight - scaledHeight) / 2;

  //     ctx.drawImage(img, dx, dy, scaledWidth, scaledHeight);

  //     const croppedDataUrl = canvas.toDataURL("image/png");
  //     setCroppedImage(croppedDataUrl); // Save final image
  //     setLogoModal(false); // Close modal
  //   };

  // };

  const handleSave = () => {
    const img = new Image();
    img.crossOrigin = "anonymous"; // This allows CORS requests
    img.src = image;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const desiredWidth = 200;
      const desiredHeight = desiredWidth / aspectRatio;

      canvas.width = desiredWidth;
      canvas.height = desiredHeight;

      const scaledWidth = img.width * zoom;
      const scaledHeight = img.height * zoom;

      const dx = (desiredWidth - scaledWidth) / 2;
      const dy = (desiredHeight - scaledHeight) / 2;

      ctx.drawImage(img, dx, dy, scaledWidth, scaledHeight);

      const croppedDataUrl = canvas.toDataURL("image/png");
      if (isZoomedImg) {
        setCroppedImage(croppedDataUrl);
      } else {
        setCroppedImage(image);
      }
      setIsZoomedImg(false);

      setLogoModal(false); // Close modal
    };
  };

  const handleDeleteImage = () => {
    setImage(null);
    setImageName("");
    setImageFile(null);
    setCheckEditImage(true);
    // toast.success("Logo delete Press save button!");
  };

  const handleEditImage = () => {
    if (image || companyProfileDetails?.logo !== null) {
      //console.log("edit----", image);
      setLogoModal(true);
    }
  };
  const handleLogoCancel = () => {
    setLogoModal(false);
  };

  const LogoModal = () => {
    const imageHeight = 300 / aspectRatio;

    return (
      <div className="ctm_modal_dialog">
        <div className="ctm_modal_content">
          <Modal.Header>
            {/* <Modal.Title>
              <img src={imgplusIcon} className="me-2" />
              Add Company Logo
              <img
                src={faCross}
               className="ms-2"
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={handleSave} // your custom function
              />
            </Modal.Title> */}

            <div className="d-flex justify-content-between align-items-center w-100">
              {/* Left: Plus icon + title */}
              <div className="d-flex align-items-center">
                <img src={imgplusIcon} className="me-2" alt="plus" />
                <span className="h4">Add Company Logo</span>
                <img src={HelpIcon} className="ms-2" alt="plus" style={{ cursor: "pointer" }} />
              </div>

              {/* Right: Cross icon */}
              <img
                src={CrossIcon}
                className="ms-2"
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={handleLogoCancel}
              />
            </div>
          </Modal.Header>
          <Modal.Body className='h-auto'>
            <div className="aspect_ratio">
              <label> Select Aspect Ratio</label>
              {aspectRatios.map((ratio) => (
                <label
                  key={ratio.value}
                  style={radioButtonStyle}
                  className="me-3"
                >
                  <input
                    type="radio"
                    value={ratio.value}
                    checked={aspectRatio === ratio.value}
                    onChange={handleAspectRatioChange}
                  />
                  {ratio.label}
                </label>
              ))}
            </div>

            <div className="cropper-container">
              <div class="cropper-wrap-box">
                <img
                  src={image}
                  alt="Selected"
                  style={{
                    width: "200px",
                    height: `${imageHeight}px`,
                    maxHeight: "300px",
                    transform: `scale(${zoom})`,
                    transition: "transform 0.2s ease-in-out",
                  }}
                />
              </div>
            </div>

            <div className="zoomin_cntrols">
              <button onClick={zoomOut} className="icon_btn">
                -
              </button>
              <progress
                value={zoom - 1}
                max="2"
                style={{ width: "100%", height: "14px" }}
              />
              <button onClick={zoomIn} className="icon_btn">
                +
              </button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleLogoCancel} variant="light">
              Cancel
            </Button>
            <Button onClick={handleSave} variant="primary">
              Save
            </Button>
          </Modal.Footer>
        </div>
      </div>
    );
  };

  const handleShowcustomModal = () => setCustomShowModal(true);
  const handlecustomModalClose = () => setCustomShowModal(false);

  // const userInfo = useSelector((state) => state.login.loginUserInfo);
  // const uid = userInfo?.uid;

  const logoname = logoMaker(companyProfileDetails?.company_name);

  const CustomModal = ({ show, handleClose }) => {
    return (
      <Modal
        show={show}
        onHide={handleClose}
        className="confirmation_model"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="text-center">
          <h3>
            Are you sure<br></br> you want to save changes?
          </h3>
          <p>Changes will be applied to all current jobs.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updateCompanyProfile}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const calculateProfileCompletion = () => {
    let completionPercentage = 0;

    if (companyProfileDetails?.company_name?.trim()) completionPercentage += 20;
    if (companyProfileDetails?.description?.trim()) {
      const wordCount = companyProfileDetails?.description
        .trim()
        .split(/\s+/).length;
      completionPercentage += wordCount < 100 ? 10 : 30;
    }
    if (companyProfileDetails?.logo) completionPercentage += 10;
    if (companyProfileDetails?.number_of_employees) completionPercentage += 10;
    if (companyProfileDetails?.company_type) completionPercentage += 5;
    if (companyProfileDetails?.location) completionPercentage += 10;
    if (companyProfileDetails?.website_url) completionPercentage += 5;
    if (companyProfileDetails?.industry) completionPercentage += 10;

    return Math.min(completionPercentage, 100);
  };

  const handleIndustrySelect = (industryName) => {
    setSelectedIndustry({
      industryName: industryName?.label,
      industryUid: industryName?.value,
    });
    setIds({
      ...ids,
      industryName: industryName?.label,
      industryUid: industryName?.value,
    });

    SetIndustrySearch(industryName?.label);
    // setIndustrySearchDropdown(false);
    // setIndustries([]);
  };

  const handleIndustrySearchChange = (e) => {
    SetIndustrySearch(e.target.value);
    setIndustrySearchDropdown(true);
  };

  // const isHeadQuerterHandleApi = (LocationQuery) => {
  //   const url = `https://api-jaipur.lywo.in/account-api/location-list-api/?page=1&limit=500&search=${LocationQuery}`;
  //   LocationSelection(url)
  //     .then((res) => {
  //       setLocation(res.data.response);
  //     })
  //     .catch((error) => {
  //       if (
  //         error?.response?.status === 401 ||
  //         error?.response?.data?.detail?.includes(
  //           "Given token not valid for any token type"
  //         )
  //       ) {
  //         removeToken();
  //         navigate("/loginwithpassword");
  //       }
  //     });
  // };
  const getHeadQuerterHandleApi = () => {
    const url = `https://api-jaipur.lywo.in/account-api/location-list-api/?limit=5000`;
    LocationSelection(url)
      .then((res) => {
        if (res?.data?.success) {
          const key = res.data.response.map((opt) => ({ value: opt.uid, label: opt.location_name }))
          setLocation(key);
        }
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.data?.detail?.includes(
            "Given token not valid for any token type"
          )
        ) {
          removeToken();
          navigate("/loginwithpassword");
        }
      });
  };
  useEffect(() => {
    getHeadQuerterHandleApi()
  }, [])

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     isHeadQuerterHandleApi(searchLocationTerm);
  //   }, 500);
  //   return () => {
  //     clearTimeout(timeoutId);
  //   };
  // }, [searchLocationTerm]);

  const handleLocationSelect = (LocationName) => {
    setSelectedLocation({
      name: LocationName?.label,
      uid: LocationName?.value,
    });
    setIds({
      ...ids,
      locationUid: LocationName?.value,
      location_name: LocationName?.label,
    });
    setLocationSearchTerm(LocationName?.label);
    // setLocationSearchDropdown(false);
    // setLocation([]);
  };

  const handleLocationSearchChange = (e) => {
    setLocationSearchTerm(e.target.value);
    setLocationSearchDropdown(true);
  };
  const handlecloseLocationDrop = (e) => {
    setLocationSearchTerm("")
    setLocationSearchDropdown(false)
    setTimeout(() => {
      setLocation([])
    }, 200);
  }
  const handleCloseIndustryCombo = (e) => {
    SetIndustrySearch("")
    setIndustrySearchDropdown(false)
    setTimeout(() => {
      setIndustries([])
    }, 200);
  }

  const updateCompanyProfile = async () => {
    if (companyUpdateError?.websiteError) {
      console.log("Invalid URL, cannot submit.");
      return;
    }

    try {
      const data = new FormData();

      // data.append("description", description);
      // data.append("website_url", website);
      // data.append("company_type", selectedCompanyType);
      // data.append("number_of_employees", noOfEmploy);
      // data.append("industry", ids?.industryUid);
      // data.append("location", ids?.locationUid);
      // data.append("logo", imageFile);

      // Array compare helper
      const arraysAreEqual = (arr1, arr2) => {
        if (!arr1 || !arr2) return false;
        if (arr1.length !== arr2.length) return false;
        return arr1.every((val) => arr2.includes(val));
      };

      // Conditional appends
      // if (description) {
      data.append("description", description);
      // }

      // if (website) {
      data.append("website_url", website);
      // }

      // if (selectedCompanyType) {
      data.append("company_type", selectedCompanyType);
      // }

      // if (noOfEmploy) {
      data.append("number_of_employees", noOfEmploy);
      // }

      // if (industries.length > 0) {
      // data.append("industry", industries[0]?.uid);
      data.append("industry", ids?.industryUid);
      // }

      // if (Location.length > 0) {
      // data.append("location", Location[0]?.uid);
      data.append("location", ids?.locationUid);
      // }

      // if (!imageFile || checkEditImage) {
      //   data.append("logo", imageFile);
      // }

      // if (checkEditImage) {
      //   data.append("logo", imageFile);
      // } else {
      //   data.append("logo", imageFile);
      // }
      if (imageFile && isBinaryFile(imageFile)) {
        data.append("logo", imageFile)
      }

      // Now send the `data` via your API call

      const response = await axios.put(
        `https://api-jaipur.lywo.in/account-api/update-company-api/${compantUid}/`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response?.data?.success) {
        setCompanyUpdateError((prevState) => ({
          ...prevState,
          websiteError: "",
        }));
        toast.success("Company Profile has been updated successfully!")
      }
    } catch (error) {
      // console.log("erooor------>>>", error);
      // setCompanyUpdateError.websiteError(error?.response?.data?.response?.website_url[0]);
      const errorResponse = error?.response?.data?.response;

      // Update the state with the appropriate error messages
      setCompanyUpdateError((prevState) => ({
        ...prevState,
        websiteError: errorResponse?.website_url?.[0] || "",
        logoError: errorResponse?.logo_url?.[0] || "", // Handle logo error if available
      }));
    }

    handlecustomModalClose();
    // handleClose();
  };

  const handleUpdate = (updatedDescription) => {
    setDescription(updatedDescription);
  };

  const handleWebsite = (e) => {
    const url = e.target.value;
    setWebsite(url);

    const websiteError =
      // !url || /^https?:\/\//i.test(url) ? "" : "Invalid Website URL";
      !url || /^(https?:\/\/|www\.)\S+$/.test(url) ? "" : "Invalid Website URL";

    setCompanyUpdateError((prevState) => ({
      ...prevState,
      websiteError,
    }));
  };

  const handleCompanyTypeChange = (e) => {
    setSelectedCompanyType(e.value);
    setCompanyTypeValue(e)
  };

  const handleNoOfTypeEmployChange = (e) => {
    setnoOfEmploy(e.value);
    setCompanySizeValue(e)
  };

  useEffect(() => {
    setCompletionPercentage(calculateProfileCompletion());
  }, [companyProfileDetails]);

  // const isIndustryHandleApi = (query) => {
  //   const url = `https://api-jaipur.lywo.in/account-api/industry-list-api/?page=1&limit=500&search=${query}`;
  //   IndustrySelection(url)
  //     .then((res) => {
  //       setIndustries(res.data.response);
  //     })
  //     .catch((error) => {
  //       if (
  //         error?.response?.status === 401 ||
  //         error?.response?.data?.detail?.includes(
  //           "Given token not valid for any token type"
  //         )
  //       ) {
  //         //console.log("Token expired, redirecting to login");
  //         removeToken();
  //         navigate("/loginwithpassword");
  //       }
  //     });
  // };
  const getIndustryHandleApi = () => {
    const url = `https://api-jaipur.lywo.in/account-api/industry-list-api/?limit=500`;
    IndustrySelection(url)
      .then((res) => {
        if (res?.data?.success) {
          const key = res.data.response.map((opt) => ({ value: opt.uid, label: opt.industry_name }))
          setIndustries(key);
        }
      })
      .catch((error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.data?.detail?.includes(
            "Given token not valid for any token type"
          )
        ) {
          //console.log("Token expired, redirecting to login");
          removeToken();
          navigate("/loginwithpassword");
        }
      });
  };

  useEffect(() => {
    getIndustryHandleApi()
  }, [])

  const shouldShowRecommendation = () => {   
    if (
      !companyProfileDetails?.logo ||
      !companyProfileDetails?.website_url ||
      !companyProfileDetails?.industry ||
      !companyProfileDetails?.industry || !companyProfileDetails?.description || (!selectedCompanyType || !companyProfileDetails?.company_type)
    || !companyProfileDetails?.number_of_employees || (!companyProfileDetails?.location || !searchLocationTerm)
    ) {
      return "";
    } else {
      return 'summary-full';
    }   
  };

  // const filePath = companyProfileDetails?.logo;

  // const LogoName = filePath?.split("/").pop();

  console.log(
    "companyProfileDetails?.logo----->>>",
    companyProfileDetails?.logo
  );

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      size="lg"
      className="cmprofile_mdl"
    >
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <aside className="model_sidebar col-md-2">
            <div className="md_sdrlogo">
              <img src={cprofilelogo} alt="" onClick={handleClose} />
            </div>
            <Nav variant="pills" className="flex-column mdl_sdbarmenu">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  Profile<span>{completionPercentage}% Complete</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="second">
                  Users
                  <span>
                    {companyProfileDetails?.active_user} Active,
                    {companyProfileDetails?.pending_user} Pending
                  </span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </aside>
          <Col md={10} className="cprofile_right">
            <Modal.Header closeButton className="fixed-header">
              <Modal.Title>Company Settings</Modal.Title>
            </Modal.Header>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Modal.Body>
                  <Row>
                    <Col md={12}>
                      <div className="mdl_pagetitle d-flex justify-content-between align-items-center">
                        <h5>Basic Information</h5>
                        <div className="btn_group">
                          <Button
                            variant="link"
                            className="me-2"
                            onClick={handleClose}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="primary"
                            onClick={handleShowcustomModal}
                            disabled={!!companyUpdateError?.websiteError}
                          >
                            Save
                          </Button>
                          <CustomModal
                            show={customModalshowcustomModal}
                            handleClose={handlecustomModalClose}
                          />
                        </div>
                      </div>
                      <Card className="form_card">
                        <Card.Body>
                          <Form>
                            <Row>
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label className="required">
                                    Company Name
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Company Name"
                                    value={companyProfileDetails?.company_name}
                                  />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Description</Form.Label>
                                  <TextEditor
                                    data={companyProfileDetails?.description}
                                    onUpdate={handleUpdate}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label>Website</Form.Label>
                                  <Form.Control
                                    type="url"
                                    placeholder="Website"
                                    onChange={handleWebsite}
                                    value={website}
                                  />
                                  {companyUpdateError?.websiteError && (
                                    <p className="error">
                                      {companyUpdateError?.websiteError}
                                    </p>
                                  )}
                                </Form.Group>
                                <Form.Group className="col-md-12 mb-3 relative">
                                  <Form.Label>Industry</Form.Label>
                                  {/* <Form.Control
                                    type="text"
                                    placeholder="Search for an industry.."
                                    value={IndustrySearch}
                                    onChange={handleIndustrySearchChange}
                                    onBlur={handleCloseIndustryCombo}
                                  />

                                  {IndustrySearchDropdown &&
                                    industries.length > 0 && (
                                      <div className="ctm_dropdown ct_scrollbar">
                                        <ul>
                                          {industries.map(
                                            (industry) =>
                                              IndustrySearch !==
                                              industry?.industry_name && (
                                                <li
                                                  key={industry.id}
                                                  onClick={() =>
                                                    handleIndustrySelect(
                                                      industry
                                                    )
                                                  }
                                                >
                                                  {industry?.industry_name}
                                                </li>
                                              )
                                          )}
                                        </ul>
                                      </div>
                                    )}

                                  {IndustrySearchDropdown &&
                                    industries.length === 0 && (
                                      <p className="error">
                                        No data found
                                      </p>
                                    )} */}
                                  <Select
                                    options={industries}
                                    value={industries.find((opt) => opt.label === IndustrySearch)}
                                    isSearchable={true}
                                    noOptionsMessage={() => "No results found"}
                                    placeholder="Search for an industry.."
                                    // filterOption={(option, inputValue) => {
                                    //   if (!inputValue) return false; // hide all options until user types
                                    //   return option.label.toLowerCase().includes(inputValue.toLowerCase());
                                    // }}
                                    onChange={handleIndustrySelect}
                                    className="react_selectbox"
                                    styles={customStyles}
                                  />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                  <Form.Label>Company Type</Form.Label>
                                  {/* <Form.Select
                                    aria-label="Default select example"
                                    value={selectedCompanyType}
                                    onChange={handleCompanyTypeChange}
                                  >
                                    <option>
                                      {companyProfileDetails?.company_type
                                        ? companyProfileDetails?.company_type
                                        : "Company Type"}
                                      {selectedCompanyType}
                                    </option>
                                    <option value="Publice-Company">
                                      Public Company
                                    </option>
                                    <option value="Self-employed">
                                      Self-employed
                                    </option>
                                    <option value="Government-Agency">
                                      Government Agency
                                    </option>
                                    <option value="Nonprofit">Nonprofit</option>
                                    <option value="Sole-Proprietorship">
                                      Sole Proprietorship
                                    </option>
                                    <option value="Privately-held">
                                      Privately held
                                    </option>
                                    <option value="Partnership">
                                      Partnership
                                    </option>
                                  </Form.Select> */}
                                  <Select value={companyTypeValue} options={companyTypeOption} onChange={handleCompanyTypeChange} className="react_selectbox" styles={customStyles} />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Company Size</Form.Label>
                                  {/* <Form.Select
                                    aria-label="Default select example"
                                    value={noOfEmploy}
                                    onChange={handleNoOfTypeEmployChange}
                                  >
                                    <option>
                                      {companyProfileDetails?.number_of_employees
                                        ? companyProfileDetails?.number_of_employees
                                        : "Company Size"}
                                    </option>

                                    <option value="1-5-employees">
                                      1 - 5 employees
                                    </option>
                                    <option value="6-10-employees">
                                      6 - 10 employees
                                    </option>
                                    <option value="11-50-employees">
                                      11 - 50 employees
                                    </option>
                                    <option value="51-200-employees">
                                      {" "}
                                      51 - 200 employees{" "}
                                    </option>

                                    <option value="201-500-employees">
                                      201 - 500 employees
                                    </option>
                                    <option value="501-1,000-employees">
                                      501 - 1,000 employees
                                    </option>
                                    <option value="1,001-5,000-employees">
                                      1,001 - 5,000 employees
                                    </option>
                                    <option value="5,001-10,000-employees">
                                      5,001 - 10,000 employees
                                    </option>
                                    <option value="More-than-10000-employees">
                                      More than 10,000 employees
                                    </option>
                                  </Form.Select> */}
                                  <Select value={companySizeValue} options={companySizeOption} onChange={handleNoOfTypeEmployChange} className="react_selectbox" styles={customStyles} />
                                </Form.Group>

                                <Form.Group className="mb-3 relative">
                                  <Form.Label>Headquarter</Form.Label>
                                  {/* <Form.Control
                                    type="text"
                                    placeholder="Search for an Headquarter..."
                                    value={searchLocationTerm}
                                    onChange={handleLocationSearchChange}
                                    onBlur={handlecloseLocationDrop}
                                  />

                                  {LocationSearchDropdown &&
                                    Location.length > 0 && (
                                      <div className="ctm_dropdown ct_scrollbar">
                                        <ul>
                                          {Location.map(
                                            (item) =>
                                              searchLocationTerm !==
                                              item?.location_name && (
                                                <li
                                                  key={item.id}
                                                  onClick={() =>
                                                    handleLocationSelect(item)
                                                  }
                                                >
                                                  {item?.location_name}
                                                </li>
                                              )
                                          )}
                                        </ul>
                                      </div>
                                    )}

                                  {LocationSearchDropdown &&
                                    Location.length === 0 && (
                                      <p className="error">Headquarter Not found </p>
                                    )} */}
                                  <Select
                                    options={Location}
                                    value={Location.find((opt) => opt.label === searchLocationTerm)}
                                    isSearchable={true}
                                    noOptionsMessage={() => "No results found"}
                                    placeholder="Search for an Headquarter..."
                                    // filterOption={(option, inputValue) => {
                                    //   if (!inputValue) return false; // hide all options until user types
                                    //   return option.label.toLowerCase().includes(inputValue.toLowerCase());
                                    // }}
                                    className="react_selectbox"
                                    onChange={handleLocationSelect}
                                    styles={customStyles}
                                  />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                  <Form.Label>Add Company Logo</Form.Label>

                                  {!companyProfileDetails?.logo &&
                                    !imageFile ? (
                                    <div
                                      className="cmp_uploder file-upload-box"
                                      {...getRootProps()}
                                    >
                                      <div className="upload-content">
                                        <input {...getInputProps()} />
                                        <i className="fas fa-cloud-upload-alt upload-icon"></i>
                                        <h5>
                                          <strong className="text-primary">
                                            Click to upload
                                          </strong>{" "}
                                          or Drag & Drop
                                        </h5>
                                        <small className="text-muted mb-0">
                                          SVG, PNG, JPG or GIF (Recommended
                                          aspect ratio: 1:1 or 2:3)
                                        </small>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="selected_logo">
                                      {/* {LogoName ? (
                                        <label>{LogoName}</label>
                                      ) : ( */}
                                      <label>{imageName}</label>
                                      {/* )} */}
                                      <div className="d-flex">
                                        <Button
                                          variant="link"
                                          onClick={handleEditImage}
                                        >
                                          <img src={imgpEdit} />
                                        </Button>
                                        <Button
                                          variant="link"
                                          className=" me-2"
                                          onClick={handleDeleteImage}
                                        >
                                          <img src={imgpTrash} />
                                        </Button>
                                      </div>
                                    </div>
                                  )}

                                  {showLogoModal && (
                                    <LogoModal
                                      onClose={() => setLogoModal(false)}
                                    />
                                  )}

                                  {companyUpdateError.logoError && (
                                    <p className="error-message">
                                      {companyUpdateError.logoError}
                                    </p>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>
                          </Form>
                        </Card.Body>
                      </Card>
                    </Col>
                    <Col md={3} className={`cmp_details sd-rightFixed ${shouldShowRecommendation()}`}>
                      <Accordion defaultActiveKey="0" flush>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>Company Details</Accordion.Header>
                          <Accordion.Body>
                            {companyProfileDetails?.logo || image !== null ? (
                              <div className="cmp_logo mt-1">
                                <span className="cmp_textlogo">
                                  <img
                                    src={
                                      croppedImage
                                      //|| `https://api-jaipur.lywo.in${companyProfileDetails?.logo}`
                                    }
                                    alt="Logo"
                                  />
                                </span>
                              </div>
                            ) : (
                              <div className="cmp_logo mt-1">
                                <span className="cmp_textlogo">{logoname}</span>
                              </div>
                            )}

                            <ul className="cmp_info ct_scrollbar">
                              <li>
                                <strong>
                                  {companyProfileDetails?.company_name}
                                </strong>
                              </li>
                              <li>
                                {website
                                  ? website
                                  : companyProfileDetails?.website_url}
                              </li>
                              <li>
                                {IndustrySearch
                                  ? IndustrySearch
                                  : companyProfileDetails?.industry
                                    ?.industry_name}
                              </li>
                              <li>
                                {selectedCompanyType
                                  ? selectedCompanyType
                                  : companyProfileDetails?.company_type}
                              </li>
                              <li>
                                {noOfEmploy
                                  ? noOfEmploy
                                  : companyProfileDetails?.number_of_employees}
                              </li>
                              <li>
                                {searchLocationTerm
                                  ? searchLocationTerm
                                  : companyProfileDetails?.location
                                    ?.location_name}
                              </li>
                            </ul>
                            <p className="cpm_dic ct_scrollbar"
                              dangerouslySetInnerHTML={{
                                __html: companyProfileDetails?.description,
                              }}>
                            </p>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>
                      <div className="rects-panel bottom-fixed">
                        {shouldShowRecommendation()== '' && <h5>Recommendations</h5>}                       
                        <ul className="rects_list">
                          {!companyProfileDetails?.logo && (
                            <li>
                              <img src={starIcon} />
                              Add Logo
                            </li>
                          )}

                          {(!companyProfileDetails?.website_url ||
                            companyProfileDetails.website_url.trim() === "") &&
                            !website && (
                              <li>
                                <img src={starIcon} alt="star" />
                                Add Website
                              </li>
                            )}

                          {!companyProfileDetails?.industry &&
                            !IndustrySearch && (
                              <li>
                                <img src={starIcon} />
                                Add Industry Type
                              </li>
                            )}

                          {(!companyProfileDetails?.description ||
                            companyProfileDetails.description
                              .replace(/<[^>]*>/g, "")
                              .trim() === "") && (
                              <li>
                                <img src={starIcon} alt="star" />
                                Add Description
                              </li>
                            )}

                          {(!companyProfileDetails?.selectedCompanyType &&
                            !selectedCompanyType) ||
                            (selectedCompanyType == "Company Type" && (
                              <li>
                                <img src={starIcon} />
                                Add Company Type
                              </li>
                            ))}

                          {(!companyProfileDetails?.number_of_employees &&
                            !noOfEmploy) ||
                            (noOfEmploy == "Company Size" && (
                              <li>
                                <img src={starIcon} />
                                Add Company Size
                              </li>
                            ))}

                          {!companyProfileDetails?.location &&
                            !searchLocationTerm && (
                              <li>
                                <img src={starIcon} />
                                Add Headquarter
                              </li>
                            )}
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <Modal.Body>
                  <AddUserManagement />
                </Modal.Body>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Modal>
  );
};


const radioButtonStyle = {
  display: "block",
  margin: "10px 0",
  cursor: "pointer",
};

export default CompanyEditProfile;
